export default {"src":"/_next/static/media/logo-american-express.3c7150a1.svg","height":32,"width":61,"blurWidth":0,"blurHeight":0};